/**
 * Opengater Locations (8008) admin hooks. Phase 1: options + squads CRUD.
 * Paths `/api/v1/admin/...`.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
// ─── Options ────────────────────────────────────────────────────────────────
const OPT_PATH = '/api/v1/admin/options';
const OPT_KEY = ['og', 'loc-options'];
export function useOgOptions() {
    return useQuery({ queryKey: OPT_KEY, queryFn: () => apiOg('locations', OPT_PATH) });
}
export function useCreateOgOption() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiOg('locations', OPT_PATH, { method: 'POST', body }),
        onSuccess: () => qc.invalidateQueries({ queryKey: OPT_KEY }),
    });
}
export function useUpdateOgOption() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, patch }) => apiOg('locations', `${OPT_PATH}/${id}`, { method: 'PATCH', body: patch }),
        onSuccess: () => qc.invalidateQueries({ queryKey: OPT_KEY }),
    });
}
export function useDeleteOgOption() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiOg('locations', `${OPT_PATH}/${id}`, { method: 'DELETE' }),
        onSuccess: () => qc.invalidateQueries({ queryKey: OPT_KEY }),
    });
}
// ─── Squads ─────────────────────────────────────────────────────────────────
const SQ_PATH = '/api/v1/admin/squads';
const SQ_KEY = ['og', 'squads'];
export function useOgSquads() {
    return useQuery({ queryKey: SQ_KEY, queryFn: () => apiOg('locations', SQ_PATH) });
}
export function useCreateOgSquad() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => apiOg('locations', SQ_PATH, { method: 'POST', body }),
        onSuccess: () => qc.invalidateQueries({ queryKey: SQ_KEY }),
    });
}
export function useUpdateOgSquad() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, patch }) => apiOg('locations', `${SQ_PATH}/${id}`, { method: 'PATCH', body: patch }),
        onSuccess: () => qc.invalidateQueries({ queryKey: SQ_KEY }),
    });
}
export function useDeleteOgSquad() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiOg('locations', `${SQ_PATH}/${id}`, { method: 'DELETE' }),
        onSuccess: () => qc.invalidateQueries({ queryKey: SQ_KEY }),
    });
}
// ─── Cache clear (DELETE actions; bearer, no x-api-key) ─────────────────────
/** Clear a parameterless cache: 'locations' | 'tariff/default' | 'all'. */
export function useClearCache() {
    return useMutation({
        mutationFn: (target) => apiOg('locations', `/api/v1/admin/cache/${target}`, { method: 'DELETE' }),
    });
}
/** Clear one user's cache by globalauth id. */
export function useClearUserCache() {
    return useMutation({
        mutationFn: (globalauthId) => apiOg('locations', `/api/v1/admin/cache/user/${encodeURIComponent(globalauthId)}`, {
            method: 'DELETE',
        }),
    });
}
